import styled from 'styled-components';
import { Title1 } from '@common/components/Typography';

export const CategoryItemsWrapper = styled.div`
  padding: 40px 0;
`;

export const ItemsTitle = styled(Title1)`
  margin: 12px 0 5px;
`;

export const ProductGridWrapper = styled.div`
  padding: 20px 0;
`;
